// QUERIES

const questionsFragment = `
  fragment questionsFragment on Questionnaire {
    questions {
      title
      identifier
      position
      description
      info
      iconName
      fieldGroups {
        title
        key
      }
      constraints {
        scope
        reference
        minValue
        maxValue
        warningMessage
      }
      fields {
        title
        fieldGroupId
        fieldKey
        fieldValue
        fieldType
        fieldInputType
        fieldDefaultValue
        fieldMin
        fieldMax
        values
        enabled
        onAction {
          fieldValueChange {
            newValue
            states {
              fieldKey
              fieldValue
              fieldMax
              fieldMin
              fieldInputType
              fieldKeyGroup
              enabled
            }
          }
        }
        iconName
      }
    }
  }
`;

export const basicQuestionnaireInfoFragment = `
  fragment basicQuestionnaireInfoFragment on Questionnaire {
    title
    description
    info
    position
    id
  }
`;

export const questionnaireFragment = `
  fragment questionnaireFragment on Questionnaire {
    ...basicQuestionnaireInfoFragment
    ...questionsFragment
  }
  ${basicQuestionnaireInfoFragment}
  ${questionsFragment}
`;

export const wizardBodyFragment = `
  fragment wizardBodyFragment on Wizard {
    constraints {
      minValue
      maxValue
      scope
      reference
      warningMessage
    }
    languageCode
    nodes {
    id
    parentId
    kind
    position
    folderName
    folderDescription
    originId
    }
    projectNodeId
    projectId
    currentStep
    totalSteps
    availableSteps
    subType
    topology
    fieldKeyGroup
  }
`;

const FetchWizardQry = `
  query ($input: GetWizardInput!) {
    fetchWizard(
      input: $input
    ) {
      ...wizardBodyFragment
      currentQuestionnaire {
        ...questionnaireFragment
      }
      questionnaires {
        ...basicQuestionnaireInfoFragment
      }
    }
  }
  ${wizardBodyFragment}
  ${questionnaireFragment}
`;

const FetchWizardStepQuestionnaire = `
  query ($input:GetQuestionnaireInput!) {
    fetchWizardStepQuestionnaire(
      input: $input) {
      ...questionnaireFragment
    }
  }
  ${questionnaireFragment}
`;

const TopologyCopyAction = `
  query (
    $input:GetTopologyCopyActionInput!
  ) {
    topologyCopyAction(
      input: $input
    )
  }
`;

export { FetchWizardStepQuestionnaire, TopologyCopyAction, FetchWizardQry };
